/* global locales */
/* jshint camelcase: false, -W098, -W030, -W055, -W003, -W116, -W117, -W069 */
import angular from 'angular';
import 'angular-bootstrap';
import locales from '../../locale';
import './filesServices';
import '../users/appUsersServices';

const filesControllers = angular.module('applicationModule.filesControllers', [
    'applicationModule.filesServices',
    'applicationModule.appUsersServices',
    'commonModule.localizationMapService',
    'ui.bootstrap'
]);

// Groups List Controller
filesControllers.controller('FilesController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'File', 'growl', 'AppsoupAPI', '$modal', '$q', '$filter', 'Permissions', function ($scope, $rootScope, $state, $stateParams, NgTableParams, File, growl, AppsoupAPI, $modal, $q, $filter, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('files');
    $scope.application_id = $stateParams.application_id;

    $scope.nodeSelectedList = [];
    $scope.data = [];
    $scope.types = [];
    $scope.typesSell = [];
    $scope.fileError = false;
    const typesList = [
        'DIR',
        'FILE',
        'REPORT'
    ];
    const typesListSell = [
        'DIR',
        'FILE',
        'FILEXML',
        'REPORT'
    ];
    angular.forEach(typesList, function (v) {
        $scope.types.push({val: v, name: $filter('translate')('MODULES.FILES.TYPE.' + v)});
    });
    angular.forEach(typesListSell, function (v) {
        $scope.typesSell.push({val: v, name: $filter('translate')('MODULES.FILES.TYPE.' + v)});
    });

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return File.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.files.total);
                    params.count(response.files.per_page);
                    params.page(response.files.current_page);

                    $scope.package_id = response.package_id;
                    $scope.data = response.treeFile;

                    return response.files.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeFile = function (id) {
        File.remove(id, $scope.application_id)
            .then(function (data) {
                if (data.success) {
                    $state.go($state.current, {}, {reload: true});
                    growl.success('MODULES.FILES.SUCCESS.DELETE_FILE');
                } else {
                    growl.error('MODULES.FILES.ERROR.DELETE');
                }
            });
    };

    $scope.editFile = function (fileId) {
        $scope.editMode = true;
        const fileModalInstance = $modal.open({
            templateUrl: 'views/application/files/components/modal/file.tpl.html',
            controller: 'FileModalController',
            backdrop: 'static',
            resolve: {
                modalData: function () {
                    return {
                        fileId: fileId,
                        editMode: $scope.editMode,
                        types: $scope.types,
                        typesSell: $scope.typesSell,
                        packageId: $scope.package_id
                    };
                }
            }
        });
        fileModalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.FILES.SUCCESS.FILE_EDITED');
        }).catch(() => {});
    };

    // funkcje drzewa
    $scope.showButton = true;
    $scope.treeOptions = {
        beforeDrop: function (e) {
            const destNode = e.dest.nodesScope.node ? e.dest.nodesScope.node : undefined;
            if (angular.isUndefined(destNode) || destNode.type !== 'DIR') {
                return $q.reject();
            }
            const source = e.source.nodeScope.$modelValue;
            const destId = destNode.id;

            $scope.editMode = true;

            source.parent_id = destId;
            File.changeOrder(source).then(function (response) {
                const data = response.data;
                if (data.success) {
                    $scope.fileError = false;
                } else {
                    if (typeof data.error === 'object') {
                        if (data.error.image) {
                            $scope.fileError = true;
                        }
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.FILES.ERROR.NO_DROP');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
            $scope.editMode = false;

            return true;
        },
        dragStart: function () {
            $scope.showButton = false;
        },
        dragStop: function () {
            $scope.showButton = true;
        }
    };

    $scope.removeNodeConfirm = function ($event) {
        $event.stopImmediatePropagation();
    };

    function removeNodes(item) {
        if (!$scope.tableParams.data) {
            return;
        }
        angular.forEach(item.nodes, function (val) {
            angular.forEach($scope.tableParams.data, function (v, k) {
                if (v.id === item.id) {
                    $scope.tableParams.data.splice(k, 1);
                }
                if (v.id === val.id) {
                    $scope.tableParams.data.splice(k, 1);
                    removeNodes(val);
                }
            });
        });
    }

    $scope.removeReallyNode = function ($event, treeNode, type) {
        const nodeId = treeNode.$modelValue;
        File.remove(nodeId.id, $scope.application_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    removeNodes(nodeId);
                    if (type === 'DIR') {
                        growl.success('MODULES.FILES.SUCCESS.DELETE_FOLDER');
                    } else if (type === 'FILE') {
                        growl.success('MODULES.FILES.SUCCESS.DELETE_FILE');
                    } else if (type === 'REPORT') {
                        growl.success('MODULES.FILES.SUCCESS.DELETE_REPORT');
                    }
                } else {
                    growl.error('MODULES.FILES.ERROR.DELETE');
                }
            });
        treeNode.remove();
    };

    $scope.toggle = function (treeNode) {
        treeNode.toggle();
    };

    $scope.newSubItem = function (treeNode) {
        $scope.editMode = false;
        createOrUpdate(treeNode);
    };

    $scope.editItem = function (treeNode) {
        $scope.editMode = true;
        createOrUpdate(treeNode);
    };

    function createOrUpdate(treeNode) {
        const fileModalInstance = $modal.open({
            templateUrl: 'views/application/files/components/modal/file.tpl.html',
            controller: 'FileModalController',
            backdrop: 'static',
            resolve: {
                modalData: function () {
                    return {
                        nodeData: treeNode,
                        editMode: $scope.editMode,
                        types: $scope.types,
                        typesSell: $scope.typesSell,
                        packageId: $scope.package_id
                    };
                }
            }
        });
        fileModalInstance.result.then(function (data) {
            if ($scope.editMode) {
                if ($scope.tableParams.data) {
                    angular.forEach($scope.tableParams.data, function (v, k) {
                        if (v.id === data.id) {
                            $scope.tableParams.data[k] = data;
                        }
                    });
                }
            } else {
                if (!$scope.tableParams.data) {
                    $scope.tableParams.data = [];
                }
                $scope.tableParams.data.push(data);
                // Reload the table to ensure the new record is displayed
                $scope.tableParams.reload();
            }
            if (data.type === 'DIR') {
                growl.success('MODULES.FILES.SUCCESS.FOLDER_' + ($scope.editMode ? 'EDITED' : 'UPLOADED'));
            } else if (data.type === 'FILE') {
                growl.success('MODULES.FILES.SUCCESS.FILE_' + ($scope.editMode ? 'EDITED' : 'UPLOADED'));
            } else if (data.type === 'REPORT') {
                growl.success('MODULES.FILES.SUCCESS.REPORT_' + ($scope.editMode ? 'EDITED' : 'UPLOADED'));
            }
        }).catch(() => {});
    }

    $scope.shareItems = function () {
        if ($scope.nodeSelectedList.length > 0) {
            $modal.open({
                templateUrl: 'views/application/files/components/modal/fileShare.tpl.html',
                controller: 'FileShareModalController',
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            nodeSelectedList: $scope.nodeSelectedList
                        };
                    }
                }
            });
        } else {
            growl.error('MODULES.FILES.ERROR.NO_SELECTED');
        }
    };

    $scope.shareItem = function (id) {
        $modal.open({
            templateUrl: 'views/application/files/components/modal/fileShare.tpl.html',
            controller: 'FileShareModalController',
            backdrop: 'static',
            resolve: {
                modalData: function () {
                    return {
                        nodeSelectedList: [id]
                    };
                }
            }
        });
    };

    $scope.selectNode = function (node) {
        function addSelectParent(item) {
            let isFind = true;
            angular.forEach(item.$parentNodesScope.$modelValue, function (v) {
                if ($scope.nodeSelectedList.indexOf(v.id) === -1) {
                    isFind = false;
                }
            });
            if (isFind && item.$parentNodeScope != null && ($scope.nodeSelectedList.indexOf(item.$parentNodeScope.$modelValue.id) === -1)) {
                $scope.nodeSelectedList.push(item.$parentNodeScope.$modelValue.id);
            } else if (!isFind && item.$parentNodeScope != null && ($scope.nodeSelectedList.indexOf(item.$parentNodeScope.$modelValue.id) !== -1)) {
                $scope.nodeSelectedList.splice($scope.nodeSelectedList.indexOf(item.$parentNodeScope.$modelValue.id), 1);
            }
            item.$parentNodeScope != null ? addSelectParent(item.$parentNodeScope) : '';
        }

        function addSelect(item) {
            $scope.nodeSelectedList.push(item.id);
            angular.forEach(item.nodes, function (v) {
                if ($scope.nodeSelectedList.indexOf(v.id) === -1) {
                    addSelect(v);
                }
            });
        }

        function removeSelect(item) {
            $scope.nodeSelectedList.splice($scope.nodeSelectedList.indexOf(item.id), 1);
            angular.forEach(item.nodes, function (v) {
                if ($scope.nodeSelectedList.indexOf(v.id) !== -1) {
                    removeSelect(v);
                }
            });
        }

        if ($scope.nodeSelectedList.indexOf(node.$modelValue.id) === -1) {
            addSelect(node.$modelValue);
        } else {
            removeSelect(node.$modelValue);
        }

        if (node.$parentNodeScope != null) {
            addSelectParent(node);
        }
    };
}]);

filesControllers.controller('FileModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'File', 'growl', 'Permissions', '$modalInstance', 'modalData', '$modal', '$filter', '$locale', function ($scope, $rootScope, $stateParams, $state, File, growl, Permissions, $modalInstance, modalData, $modal, $filter, $locale) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('files');
    $scope.application_id = $stateParams.application_id;

    $scope.packageId = modalData.packageId;
    $scope.editMode = modalData.editMode;
    $scope.types = modalData.packageId === 'sellcentive-www' ? modalData.typesSell : modalData.types;

    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.isLoading = true;
    $scope.file = {
        app_id: $scope.application_id,
        type: $scope.types[0].val
    };
    $scope.jsonData = {};

    $scope.clearFile = function (fileName) {
        $scope.isLoading = true;
        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.isImage = false;
        $scope.fileError = false;
        const type = $scope.file.type;
        $scope.file = {
            app_id: $scope.application_id,
            type: type
        };
        $scope.file.file_name = fileName;
        $scope.jsonData = {};
        $scope.isLoading = false;
    };

    $scope.clearFile();

    if ($scope.editMode) {
        let fileId = null;
        $scope.isLoading = true;

        if (angular.isDefined(modalData.fileId)) {
            fileId = modalData.fileId;
        } else if (angular.isDefined(modalData.nodeData)) {
            fileId = modalData.nodeData.$modelValue.id;
        }

        File.get(fileId, $scope.application_id).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.fileUploaded = true;
                $scope.file = data.file;
                $scope.jsonData = angular.copy($scope.file.json_data);
                $scope.changeType($scope.file.file_name);
            } else {
                growl.error('MODULES.FILES.' + data.error);
            }
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    }

    $scope.changeType = function (fileName) {
        $scope.isLoading = true;
        File.getFileType($scope.file).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.reportTypes = [];
                angular.forEach(data.type, function (val) {
                    const tmpType = {key: val.key, label: val.label};
                    $scope.reportTypes.push(tmpType);
                });
                $scope.file.file_name = fileName;
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        File.autocomplete($scope.file, text).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.categories = data.categories;
            }
        });
    };

    $scope.categories = [];

    $scope.changeCategories = function () {
        if (angular.isDefined($scope.jsonData.categories)) {
            const tempTags = [];
            angular.forEach($scope.jsonData.categories, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.jsonData.categories = tempTags;
        }
    };

    $scope.editType = function () {
        const fileModalInstance = $modal.open({
            templateUrl: 'views/application/files/components/modal/fileType.tpl.html',
            controller: 'FileTypeModalController'
        });

        fileModalInstance.result.then(function () {
            $scope.changeType();
        }).catch(() => {});
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.file.application_id = $scope.file.app_id;
        $scope.file.json_data = angular.copy($scope.jsonData);

        if (angular.isDefined(modalData.nodeData)) {
            const nodeData = modalData.nodeData.$modelValue;
            if (!$scope.editMode) {
                $scope.file.parent_id = nodeData.id;
            }
        }

        if (angular.isDefined($scope.file.json_data.categories)) {
            const tags = [];

            angular.forEach($scope.file.json_data.categories, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value)) {
                    tags.push(value);
                }
            });

            $scope.file.json_data.categories = tags;
        }

        File.save($scope.file, $scope.upload, $scope.editMode).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.fileError = false;
                if (angular.isDefined(modalData.nodeData)) {
                    if ($scope.editMode) {
                        modalData.nodeData.file_name = data.file.file_name;
                    } else {
                        data.file.nodes = [];
                        if (!angular.isDefined(modalData.nodeData.nodes)) {
                            modalData.nodeData.nodes = [];
                        }
                        modalData.nodeData.nodes.push(data.file);
                    }
                }
                $modalInstance.close(data.file);
            } else {
                if (typeof data.error === 'object') {
                    if (data.error.name) {
                        $scope.fileError = true;
                    }
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.FILES.ERROR.NO_FILE_UPLOADED');
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.isImage = $scope.upload.type.includes('image');
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.removeFile = function () {
        if (angular.isDefined($scope.file.original_name)) {
            delete $scope.file.original_name;
        }
        $scope.upload = undefined;
        $scope.fileUploaded = false;
    };

    $scope.inputErrors = {
        'file_name': [
            {error: 'required', msg: 'FORM.ERRORS.REQUIRED'},
            {error: 'pattern', msg: 'FORM.ERRORS.FORMAT'},
            {error: 'maxlength', msg: 'ERROR.MAX.STRING'}
        ],
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.FILE'}]
    };
}]).config([
    'datepickerConfig',
    'datepickerPopupConfig',
    function (datepickerConfig, datepickerPopupConfig) {
        'use strict';
        angular.extend(datepickerConfig, {});

        angular.extend(datepickerPopupConfig, {});
    }
]);

filesControllers.controller('FileShareModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'File', 'growl', 'Permissions', '$modalInstance', '$filter', 'modalData', 'AppUsers', function ($scope, $rootScope, $stateParams, $state, File, growl, Permissions, $modalInstance, $filter, modalData, AppUsers) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('files');
    $scope.application_id = $stateParams.application_id;
    $scope.file = {
        app_id: $scope.application_id,
        nodeSelectedList: modalData.nodeSelectedList
    };
    $scope.users = [];

    $scope.upload = undefined;
    $scope.invalidContractor = undefined;
    $scope.fileUploaded = false;
    $scope.isLoading = true;

    const filesIds = $scope.file.nodeSelectedList;

    File.getShare(filesIds.toString(), $scope.file.app_id)
        .then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.isLoading = true;

                const users = [];
                const usersIds = data.usersIds;
                if (angular.isDefined(usersIds)) {
                    AppUsers.searchPayers($scope.file.app_id, '')
                        .then(function (response) {
                            const data = response.data;
                            $scope.users = data.users;
                            angular.forEach($scope.users, function (val, key) {
                                angular.forEach(usersIds, function (v) {
                                    if (v === val.id) {
                                        users.push($scope.users[key].id);
                                    }
                                });
                            });
                        });
                    $scope.file.users = users;
                }
            } else {
                growl.error('MODULES.FILES.' + data.error);
            }
        }).finally(function () {
        $scope.isLoading = false;
        $rootScope.doingResolve = false;
    });

    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        AppUsers.searchPayers($scope.file.app_id, text)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    let users = [];
                    users = data.users;
                    angular.forEach($scope.file.users, function (val) {
                        angular.forEach(data.users, function (v, k) {
                            if (val === v.id) {
                                users.splice(k, 1);
                            }
                        });
                    });
                    $scope.users = users;
                } else {
                    growl.error('MODULES.USERS.' + data.error);
                }
            });
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        delete $scope.file.fileName;
        $scope.$apply();
    };

    $scope.removeFile = function () {
        delete $scope.upload;
        $scope.fileUploaded = false;
        delete $scope.file.fileName;
        $scope.invalidContractor = undefined;
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.file.application_id = $scope.file.app_id;
        $scope.isLoading = true;

        File.saveShare($scope.file, $scope.upload).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.FILES.SUCCESS.SHARED');
                $modalInstance.close();
            } else {
                if (typeof data.error === 'object') {
                    if (data.error.contractors) {
                        $scope.invalidContractor = data.error.contractors;
                    }
                } else {
                    growl.error('MODULES.FILES.ERROR.SHARED');
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
}]);

filesControllers.controller('FileTypeModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'File', 'growl', 'Permissions', '$modalInstance', 'App', function ($scope, $rootScope, $stateParams, $state, File, growl, Permissions, $modalInstance, App) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('files');
    $scope.application_id = $stateParams.application_id;

    $scope.isLoading = true;
    $scope.newType = {};
    $scope.addNewType = false;
    $scope.fileTypes = [];
    $scope.editedType = [];

    App.get($scope.application_id)
        .then(function (response) {
            if (angular.isDefined(response)) {
                const data = response.data;
                const app = data.application;
                const fileTypes = (app.module_attributes !== null && angular.isDefined(app.module_attributes['fileType'])) ? app.module_attributes['fileType'] : [];

                angular.forEach(fileTypes, function (val) {
                    $scope.fileTypes.push(val);
                });

                $scope.isEmpty = !(angular.isDefined($scope.fileTypes) && $scope.fileTypes.length > 0);
                $scope.isLoading = false;
            }
        });

    $scope.addType = function () {
        $scope.editedType = [];
        $scope.addNewType = true;
    };

    $scope.cancelType = function () {
        $scope.editedType = [];
        $scope.addNewType = false;
        $scope.newType = {};
    };

    $scope.saveType = function (type, edit, index) {
        $scope.$broadcast('show-errors-check-validity');
        if (edit || $scope.newType.typeForm.$valid) {
            $scope.isLoading = true;
            if (edit) {
                type.label = angular.isUndefinedNullOrEmpty($scope.newType.label) ? type.label : $scope.newType.label;
            }
            File.saveAttribute($scope.application_id, 'fileType', edit, type)
                .then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        if (edit) {
                            $scope.fileTypes[index] = (data.attribute);
                        } else {
                            $scope.fileTypes.push(data.attribute);
                        }
                        growl.success('MODULES.FILES.SUCCESS.TYPE_' + (edit ? 'EDIT' : 'NEW'));
                    } else {
                        growl.error('MODULES.FILES.ERROR.TYPE_' + (edit ? 'EDIT' : 'NEW'));
                    }
                }).finally(function () {
                $scope.isLoading = false;
            });

            $scope.addNewType = false;
            $scope.editedType = [];
            $scope.newType = {};
        }
    };

    $scope.editType = function (index) {
        $scope.editedType = [];
        $scope.addNewType = false;
        $scope.editedType[index] = true;
        $scope.newType.label = $scope.fileTypes[index].label;
    };

    $scope.deleteType = function (index) {
        $scope.isLoading = true;
        $scope.editedType = [];
        $scope.addNewType = false;
        File.removeAttribute($scope.application_id, $scope.fileTypes[index].key, 'fileType')
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.FILES.SUCCESS.DELETE_TYPE');
                    $scope.fileTypes.splice(index, 1);
                } else if (data.error) {
                    growl.error('MODULES.FILES.ERROR.DELETE_TYPE');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.close = function () {
        $modalInstance.close();
    };
}]);

export default filesControllers;
